import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useState, useEffect, useContext, useCallback } from "react";
import AccessDeniedModal from "./AccessDeniedModal";
import createAuth0Client from "@auth0/auth0-spa-js";
import config from "../dal/config";
import { CustomerStatus, OrderPhysician, RoleType } from "../dal/models";
import physicians from "../dal/physicians";
import institutionsApi from "../dal/institutions";
import { postLog } from "../dal/logging";
import { LogLevel } from "../dal/enums";
import { GetStoredInstitutionCodes } from "../utils/PhysicianHelper";
import { isNil } from "lodash";
import { ALL_PERMISSIONS } from "../constants/permissions";
import { ALL_ROLES } from "../constants/roles";
export var UserState;
(function (UserState) {
  UserState["NotLoggedIn"] = "NotLoggedIn";
  UserState["Loading"] = "Loading";
  UserState["NeedRegistration"] = "Need Registration";
  UserState["WaitingForApproval"] = "Waiting For Approval";
  UserState["Ok"] = "Ok";
  UserState["Error"] = "Error";
})(UserState || (UserState = {}));
var defaultAuth0Context = {
  isAuthenticated: false,
  loading: false,
  setPhysician: function setPhysician() {},
  userState: UserState.Loading,
  institutions: [],
  setSelectedInstitution: function setSelectedInstitution() {},
  emailVerified: false,
  isAdmin: false,
  siteRoles: [],
  isVA: false,
  allRoles: [],
  allPermissions: [],
  userManagementSupported: false,
  showUserManagementAttestationMessage: false,
  isV2ToggleVisible: false,
  isV2Ui: false,
  setIsV2Ui: function setIsV2Ui(toggled) {},
  isLoadingV2Prefs: false
};
var DEFAULT_REDIRECT_CALLBACK = function DEFAULT_REDIRECT_CALLBACK(appState) {
  document.location.replace(appState.targetUrl.href);
};
var setInstitutionPreferenceCookie = function setInstitutionPreferenceCookie(preference) {
  document.cookie = "institution_preference=".concat(preference, "; domain=.baylorgenetics.com; path=/; max-age=2592000; SameSite=Lax");
};
export var Auth0Context = React.createContext(defaultAuth0Context);
export var useAuth0 = function useAuth0() {
  return useContext(Auth0Context);
};
export var Auth0Provider = function Auth0Provider(_a) {
  var children = _a.children,
    _a$onRedirectCallback = _a.onRedirectCallback,
    onRedirectCallback = _a$onRedirectCallback === void 0 ? DEFAULT_REDIRECT_CALLBACK : _a$onRedirectCallback,
    initOptions = __rest(_a, ["children", "onRedirectCallback"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAuthenticated = _useState2[0],
    setIsAuthenticated = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    user = _useState4[0],
    setUser = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    errorGettingPhysician = _useState6[0],
    setErrorGettingPhysician = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    auth0Client = _useState8[0],
    setAuth0 = _useState8[1];
  var _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    loading = _useState0[0],
    setLoading = _useState0[1];
  var _useState1 = useState(undefined),
    _useState10 = _slicedToArray(_useState1, 2),
    physician = _useState10[0],
    setPhysician = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    institutions = _useState12[0],
    setInstitutions = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedInstitution = _useState14[0],
    setSelectedInstitution = _useState14[1];
  var _useState15 = useState(UserState.Loading),
    _useState16 = _slicedToArray(_useState15, 2),
    userState = _useState16[0],
    setUserState = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    roles = _useState18[0],
    setRoles = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    emailVerified = _useState20[0],
    setEmailVerified = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isAdmin = _useState22[0],
    setIsAdmin = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    siteRoles = _useState24[0],
    setSiteRoles = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isVA = _useState26[0],
    setIsVA = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    allPermissions = _useState28[0],
    setAllPermissions = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    allRoles = _useState30[0],
    setAllRoles = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    userManagementSupportedState = _useState32[0],
    setUserManagamentSupported = _useState32[1];
  var cachedConfig = localStorage.getItem("tenantConfig");
  var configData = cachedConfig ? JSON.parse(cachedConfig) : {};
  function convertConfig(configData) {
    return {
      audience: configData.audience,
      client_id: configData.client_id,
      domain: configData.domain,
      leeway: configData.leeway,
      redirect_uri: configData.redirect_uri,
      scope: configData.scope
    };
  }
  var converted = convertConfig(configData);
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showUserManagementAttestationMessageState = _useState34[0],
    setShowUserManagementAttestationMessage = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    isV2Ui = _useState36[0],
    setIsV2Ui = _useState36[1];
  var isV2ToggleVisible = false;
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    v2UserBlocked = _useState38[0],
    setV2UserBlocked = _useState38[1];
  var _useState39 = useState(true),
    _useState40 = _slicedToArray(_useState39, 2),
    isLoadingV2Prefs = _useState40[0],
    setIsLoadingV2Prefs = _useState40[1]; // Start as true, set to false after determining
  var hasRequestedV2PrefsRef = React.useRef(false);
  var auth0ClientRef = React.useRef(undefined);
  // Fetch V2 UI preferences when selectedInstitution changes
  useEffect(function () {
    var fetchV2Preferences = function fetchV2Preferences() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a, _b, prefsUrl, tokenForPrefs, prefsResp, prefsJson, prefersLegacy;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!selectedInstitution || !physician)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                if (hasRequestedV2PrefsRef.current) {
                  _context.next = 32;
                  break;
                }
                // V2 institution - fetch preferences
                hasRequestedV2PrefsRef.current = true;
                setIsLoadingV2Prefs(true);
                _context.prev = 5;
                prefsUrl = ((_a = window.appConfig) === null || _a === void 0 ? void 0 : _a.preferencesUrl) || "".concat(window.appConfig.v2ApiUrl, "/api/v1/physicians/").concat(physician.id, "/preferences/ui");
                tokenForPrefs = sessionStorage.getItem("authToken");
                _context.next = 10;
                return fetch(prefsUrl, {
                  method: "GET",
                  headers: Object.assign({
                    "Content-Type": "application/json"
                  }, tokenForPrefs ? {
                    Authorization: "Bearer ".concat(tokenForPrefs)
                  } : {})
                });
              case 10:
                prefsResp = _context.sent;
                if (!(prefsResp && prefsResp.ok)) {
                  _context.next = 20;
                  break;
                }
                _context.next = 14;
                return prefsResp.json();
              case 14:
                prefsJson = _context.sent;
                prefersLegacy = (_b = prefsJson === null || prefsJson === void 0 ? void 0 : prefsJson.data) === null || _b === void 0 ? void 0 : _b.prefersLegacyUi;
                setIsV2Ui(Boolean(!prefersLegacy));
                setInstitutionPreferenceCookie(prefersLegacy ? "v1" : "v2");
                _context.next = 22;
                break;
              case 20:
                setIsV2Ui(false);
                setInstitutionPreferenceCookie("v1");
              case 22:
                _context.next = 29;
                break;
              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](5);
                console.error("Error fetching UI preferences:", _context.t0);
                setIsV2Ui(false);
                setInstitutionPreferenceCookie("v1");
              case 29:
                _context.prev = 29;
                setIsLoadingV2Prefs(false);
                return _context.finish(29);
              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 24, 29, 32]]);
      }));
    };
    fetchV2Preferences();
  }, [selectedInstitution, physician]);
  useEffect(function () {
    var getUserState = function getUserState() {
      if (loading) {
        return UserState.Loading;
      }
      if (!isAuthenticated) {
        return UserState.NotLoggedIn;
      } else {
        if (errorGettingPhysician) {
          return UserState.Error;
        }
        if (!physician) {
          return UserState.NeedRegistration;
        }
        if (physician.status == CustomerStatus.WaitingForApproval) {
          return UserState.WaitingForApproval;
        }
        return UserState.Ok;
      }
    };
    setUserState(getUserState());
  }, [loading, isAuthenticated, physician, errorGettingPhysician]);
  var getUserInfo = function getUserInfo(auth0) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var user, token, cachedConfig, parcedConfig, userObject, claims, subClaim, codes, currentPhysician, institutionFound, newPhysician, faxPhone, _institutions, institutionCodes, parentInstitutionCodes, storedInstitution, institutionId, hasAdminRole;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return auth0.getUser();
            case 2:
              user = _context2.sent;
              setUser(user);
              cachedConfig = localStorage.getItem("tenantConfig");
              parcedConfig = JSON.parse(cachedConfig);
              if (!cachedConfig) {
                _context2.next = 21;
                break;
              }
              _context2.prev = 7;
              _context2.next = 10;
              return auth0.getTokenSilently({
                cacheMode: 'off',
                authorizationParams: {
                  audience: parcedConfig.audience
                }
              });
            case 10:
              token = _context2.sent;
              _context2.next = 21;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](7);
              console.error("Error getting token silently:", _context2.t0); //will remove Log the error for debugging
              if (!((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.error) === 'login_required' || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.error) === 'consent_required')) {
                _context2.next = 20;
                break;
              }
              // Auth0 server session is gone (e.g. logged out from another app).
              // Treat as unauthenticated so the login page is shown instead of
              // silently re-authenticating and redirecting back to V2 dashboard.
              setIsAuthenticated(false);
              setLoading(false);
              return _context2.abrupt("return");
            case 20:
              throw _context2.t0;
            case 21:
              if (token) {
                sessionStorage.setItem("authToken", token);
              }
              userObject = JSON.parse(JSON.stringify(user));
              sessionStorage.setItem("userEmail", userObject.email);
              if ((user === null || user === void 0 ? void 0 : user.email_verified) !== undefined) {
                setEmailVerified(user.email_verified);
              }
              _context2.next = 27;
              return auth0.getIdTokenClaims();
            case 27:
              claims = _context2.sent;
              subClaim = claims === null || claims === void 0 ? void 0 : claims["sub"];
              setRoles(claims === null || claims === void 0 ? void 0 : claims[config.auth0Config.rolesKey]);
              if (!((claims === null || claims === void 0 ? void 0 : claims[config.auth0Config.rolesKey]) && claims[config.auth0Config.rolesKey].includes("Support"))) {
                _context2.next = 36;
                break;
              }
              if (!(GetStoredInstitutionCodes().length === 0)) {
                _context2.next = 36;
                break;
              }
              _context2.next = 34;
              return getAllHospitalCodes();
            case 34:
              codes = _context2.sent;
              sessionStorage.setItem("allInstitutionCodes", codes.join(","));
            case 36:
              _context2.prev = 36;
              _context2.next = 39;
              return physicians.getCurrent();
            case 39:
              currentPhysician = _context2.sent;
              if (!currentPhysician) {
                _context2.next = 63;
                break;
              }
              sessionStorage.setItem("physicianId", currentPhysician.id.toString());
              newPhysician = new OrderPhysician(currentPhysician);
              if (currentPhysician.phoneNumbers && currentPhysician.phoneNumbers.length > 0) {
                faxPhone = currentPhysician.phoneNumbers.find(function (phone) {
                  return phone.type && phone.type.toLowerCase() === "fax";
                });
                if (faxPhone) {
                  newPhysician.fax = faxPhone.phoneNumber;
                }
              }
              if (currentPhysician.phoneNumbers && currentPhysician.phoneNumbers.length > 0) {
                newPhysician.phone = currentPhysician.phoneNumbers[0].phoneNumber;
              }
              setPhysician(new OrderPhysician(newPhysician));
              // Store T&C approval status in session storage (CEP-82)
              sessionStorage.setItem("TnCApproved", currentPhysician.attestations.tnCApproved.toString());
              _context2.next = 49;
              return physicians.getInstitutions(currentPhysician.id);
            case 49:
              _institutions = _context2.sent;
              setInstitutions(_institutions);
              institutionCodes = _institutions.map(function (i) {
                return i.institutionCode;
              });
              parentInstitutionCodes = [];
              if (currentPhysician.customerRoles) {
                parentInstitutionCodes = currentPhysician.customerRoles.map(function (role) {
                  return role.institution.parentCode;
                }).filter(function (code) {
                  return !isNil(code) && code.length > 0;
                });
              }
              sessionStorage.setItem("institutionCodes", institutionCodes.concat(parentInstitutionCodes).join(","));
              storedInstitution = sessionStorage.getItem("institutionId");
              institutionId = storedInstitution ? parseInt(storedInstitution, 10) || 0 : 0;
              if (institutionId > 0) {
                institutionFound = _institutions.find(function (x) {
                  return x.id === institutionId;
                });
              }
              if (subClaim) {
                institutionFound = _institutions.find(function (x) {
                  return x.createdByUser === subClaim;
                });
              }
              if (institutionFound) {
                setSelectedInstitution(institutionFound);
                sessionStorage.setItem("defaultInstitution", institutionFound.id.toString());
              } else {
                sessionStorage.setItem("defaultInstitution", _institutions[0].id.toString());
                setSelectedInstitution(_institutions[0]);
              }
              setErrorGettingPhysician(false);
              _context2.next = 64;
              break;
            case 63:
              setErrorGettingPhysician(true);
            case 64:
              setSiteRoles(currentPhysician === null || currentPhysician === void 0 ? void 0 : currentPhysician.customerRoles);
              setUserManagamentSupported((currentPhysician === null || currentPhysician === void 0 ? void 0 : currentPhysician.userManagementSupported) || false);
              setShowUserManagementAttestationMessage((currentPhysician === null || currentPhysician === void 0 ? void 0 : currentPhysician.showUserManagementAttestationMessage) || false);
              hasAdminRole = currentPhysician && currentPhysician.customerRoles && currentPhysician.customerRoles.some(function (role) {
                return role.roles && role.roles.some(function (r) {
                  return r.name === RoleType.SuperUser || r.name === RoleType.UserAdmin;
                });
              });
              setIsAdmin(hasAdminRole);
              _context2.next = 79;
              break;
            case 71:
              _context2.prev = 71;
              _context2.t1 = _context2["catch"](36);
              _context2.next = 75;
              return postLog(LogLevel.Error, String(_context2.t1));
            case 75:
              setPhysician(undefined);
              console.error("Error fetching user data:", _context2.t1);
              setIsAdmin(false);
              setIsVA(false);
            case 79:
              _context2.prev = 79;
              setLoading(false);
              return _context2.finish(79);
            case 82:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 13], [36, 71, 79, 82]]);
    }));
  };
  useEffect(function () {
    var initAuth0 = function initAuth0() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var auth0FromHook, initParams, cachedCfg, tenantCfg, MS_LOGOUT, returnTo, _yield$auth0FromHook$, appState, urlParams, errorDesc, ex, params, isSaml, alreadyAuthenticated, existingToken, _cachedConfig, parsedConfig, token;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Handle email verification errors (existing logic)
                if (window.location.search && window.location.search.toLowerCase().includes("error=") && window.location.search.toLowerCase().includes("verify") && window.location.search.toLowerCase().includes("email")) {
                  setEmailVerified(false);
                  window.location.replace("email-not-verified");
                }
                _context3.next = 3;
                return createAuth0Client(Object.assign(Object.assign({}, converted), initOptions.cacheLocation && {
                  cacheLocation: initOptions.cacheLocation
                }));
              case 3:
                auth0FromHook = _context3.sent;
                setAuth0(auth0FromHook);
                auth0ClientRef.current = auth0FromHook;
                // If V2 sent us here with ?logout=true, delegate to V1's SDK logout.
                // This is identical to clicking the V1 logout button — SDK clears
                // localStorage cache and properly terminates Auth0 + federated session.
                initParams = new URLSearchParams(window.location.search);
                if (!(initParams.get("logout") === "true")) {
                  _context3.next = 15;
                  break;
                }
                cachedCfg = localStorage.getItem("tenantConfig");
                tenantCfg = cachedCfg ? JSON.parse(cachedCfg) : null;
                MS_LOGOUT = "https://login.microsoftonline.com/common/oauth2/v2.0/logout";
                returnTo = (tenantCfg === null || tenantCfg === void 0 ? void 0 : tenantCfg.type) === "SAML_TENANT" ? "".concat(MS_LOGOUT, "?post_logout_redirect_uri=").concat(encodeURIComponent(tenantCfg.logoutRedirectUrl)) : window.appConfig.auth0Config.logoutRedirectUrl;
                console.log("[V2 logout] ?logout=true detected, tenantType:", tenantCfg === null || tenantCfg === void 0 ? void 0 : tenantCfg.type, "returnTo:", returnTo);
                // V1 uses auth0-spa-js v1.x — returnTo goes directly in options, not nested in logoutParams
                auth0FromHook.logout({
                  returnTo: returnTo,
                  federated: true
                });
                return _context3.abrupt("return");
              case 15:
                if (!window.location.search.includes("code=")) {
                  _context3.next = 21;
                  break;
                }
                _context3.next = 18;
                return auth0FromHook.handleRedirectCallback();
              case 18:
                _yield$auth0FromHook$ = _context3.sent;
                appState = _yield$auth0FromHook$.appState;
                onRedirectCallback(appState);
              case 21:
                if (!window.location.search.includes("error=")) {
                  _context3.next = 38;
                  break;
                }
                urlParams = new URLSearchParams(window.location.search);
                errorDesc = urlParams.get('error_description');
                if (!(errorDesc === 'v2_user_not_allowed_on_v1')) {
                  _context3.next = 28;
                  break;
                }
                setV2UserBlocked(true);
                setLoading(false);
                return _context3.abrupt("return");
              case 28:
                _context3.prev = 28;
                _context3.next = 31;
                return auth0FromHook.handleRedirectCallback();
              case 31:
                _context3.next = 38;
                break;
              case 33:
                _context3.prev = 33;
                _context3.t0 = _context3["catch"](28);
                ex = String(_context3.t0);
                _context3.next = 38;
                return postLog(LogLevel.Error, ex);
              case 38:
                // 2️⃣ Determine if SAML flow
                params = new URLSearchParams(window.location.search);
                isSaml = params.get("saml") === "true"; // 3️⃣ Check existing session
                _context3.next = 42;
                return auth0FromHook.isAuthenticated();
              case 42:
                alreadyAuthenticated = _context3.sent;
                setIsAuthenticated(alreadyAuthenticated);
                // 4️⃣ Handle SAML scenario
                if (!isSaml) {
                  _context3.next = 67;
                  break;
                }
                existingToken = sessionStorage.getItem("authToken");
                if (!(!alreadyAuthenticated && !existingToken)) {
                  _context3.next = 51;
                  break;
                }
                console.log("Not authenticated — redirecting to SAML Auth0");
                _context3.next = 50;
                return auth0FromHook.loginWithRedirect({
                  appState: {
                    targetUrl: window.location.origin + "/dashboard"
                  }
                });
              case 50:
                return _context3.abrupt("return");
              case 51:
                if (!(alreadyAuthenticated && !existingToken)) {
                  _context3.next = 67;
                  break;
                }
                console.log("Authenticated but missing token — fetching silently");
                _context3.prev = 53;
                _cachedConfig = localStorage.getItem("tenantConfig");
                parsedConfig = JSON.parse(_cachedConfig);
                _context3.next = 58;
                return auth0FromHook.getTokenSilently({
                  cacheMode: 'on',
                  authorizationParams: {
                    audience: parsedConfig.audience
                  }
                });
              case 58:
                token = _context3.sent;
                sessionStorage.setItem("authToken", token);
                console.log("Token fetched successfully via SAML silent login");
                // Redirect user to dashboard if not already there
                if (!window.location.pathname.includes("/dashboard")) {
                  window.location.replace("/dashboard");
                }
                _context3.next = 67;
                break;
              case 64:
                _context3.prev = 64;
                _context3.t1 = _context3["catch"](53);
                console.error("Error fetching SAML token:", _context3.t1);
              case 67:
                if (!alreadyAuthenticated) {
                  _context3.next = 72;
                  break;
                }
                _context3.next = 70;
                return getUserInfo(auth0FromHook);
              case 70:
                _context3.next = 73;
                break;
              case 72:
                setLoading(false);
              case 73:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[28, 33], [53, 64]]);
      }));
    };
    initAuth0();
  }, []);
  useEffect(function () {
    if (selectedInstitution) {
      sessionStorage.setItem("institutionId", selectedInstitution.id.toString());
      var hasVARole = Boolean(physician && physician.customerRoles && physician.customerRoles.some(function (role) {
        return window.appConfig.vaHospitalCodes.includes(role.institution.code) || window.appConfig.vaHospitalCodes.includes(role.institution.parentCode);
      }) || selectedInstitution && selectedInstitution.institutionCode && (window.appConfig.vaHospitalCodes.includes(selectedInstitution.institutionCode) || window.appConfig.vaHospitalCodes.includes(selectedInstitution.parentInstitutionCode)));
      setIsVA(hasVARole);
    }
  }, [selectedInstitution]);
  var handleRedirectCallback = function handleRedirectCallback() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!auth0Client) {
                _context4.next = 10;
                break;
              }
              _context4.next = 3;
              return auth0Client.handleRedirectCallback();
            case 3:
              _context4.t0 = setIsAuthenticated;
              _context4.next = 6;
              return auth0Client.isAuthenticated();
            case 6:
              _context4.t1 = _context4.sent;
              (0, _context4.t0)(_context4.t1);
              _context4.next = 10;
              return getUserInfo(auth0Client);
            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };
  var clearCrossDomainMessage = function clearCrossDomainMessage() {
    var doc = document.getElementById("ifr-for-cross-domain");
    if (doc) {
      var contentWindow = doc.contentWindow;
      if (contentWindow) {
        contentWindow.postMessage(undefined, window.appConfig.catalogUrl);
      }
    }
  };
  var handleLogOut = function handleLogOut() {
    // Cookie is cross-subdomain (.baylorgenetics.com) so V2RedirectRoute on
    // orders-qa can read it and skip auto-login after this logout redirect.
    document.cookie = "logout_initiated=1; domain=.baylorgenetics.com; path=/; max-age=60; secure; samesite=none";
    if (auth0Client) {
      auth0Client.logout.apply(auth0Client, arguments);
    }
    clearCrossDomainMessage();
    sessionStorage.clear();
    localStorage.removeItem("tenantConfig");
  };
  var getAllHospitalCodes = function getAllHospitalCodes() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var codes;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return institutionsApi.getAllInstitutionCodes();
            case 2:
              codes = _context5.sent;
              return _context5.abrupt("return", codes);
            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  };
  var fetchAllPermissions = useCallback(function () {
    try {
      setAllPermissions(ALL_PERMISSIONS);
    } catch (error) {
      console.error("Error setting permissions:", error);
    }
  }, []);
  var fetchAllRoles = useCallback(function () {
    try {
      setAllRoles(ALL_ROLES);
    } catch (error) {
      console.error("Error setting roles:", error);
    }
  }, []);
  useEffect(function () {
    if (isAuthenticated) {
      fetchAllPermissions();
      fetchAllRoles();
    }
  }, [isAuthenticated]);
  if (v2UserBlocked) {
    return React.createElement(AccessDeniedModal, {
      opened: true,
      onClose: function onClose() {
        var _a;
        sessionStorage.clear();
        (_a = auth0ClientRef.current) === null || _a === void 0 ? void 0 : _a.logout({
          returnTo: window.location.origin
        });
      },
      v2LoginUrl: window.appConfig.v2FEUrl
    });
  }
  if (auth0Client) {
    return React.createElement(Auth0Context.Provider, {
      value: {
        isAuthenticated: isAuthenticated,
        user: user,
        loading: loading,
        handleRedirectCallback: handleRedirectCallback,
        physician: physician,
        setPhysician: setPhysician,
        institutions: institutions,
        setSelectedInstitution: setSelectedInstitution,
        selectedInstitution: selectedInstitution,
        userState: userState,
        roles: roles,
        getIdTokenClaims: function getIdTokenClaims() {
          return auth0Client.getIdTokenClaims.apply(auth0Client, arguments);
        },
        loginWithRedirect: function loginWithRedirect() {
          return auth0Client.loginWithRedirect.apply(auth0Client, arguments);
        },
        getTokenSilently: function getTokenSilently() {
          return auth0Client.getTokenSilently.apply(auth0Client, arguments);
        },
        logout: function logout() {
          return handleLogOut.apply(void 0, arguments);
        },
        emailVerified: emailVerified,
        isAdmin: isAdmin,
        siteRoles: siteRoles,
        isVA: isVA,
        allRoles: allRoles,
        allPermissions: allPermissions,
        isV2ToggleVisible: isV2ToggleVisible,
        isV2Ui: isV2Ui,
        setIsV2Ui: setIsV2Ui,
        isLoadingV2Prefs: isLoadingV2Prefs,
        userManagementSupported: userManagementSupportedState,
        showUserManagementAttestationMessage: showUserManagementAttestationMessageState
      }
    }, children);
  }
  return null;
};